import { Grid } from '@mui/material';
import { PqrReceivedThroughParamsDataProps } from './props';
import { usePqrReceivedThroughData } from './hook';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const PqrReceivedThroughData = (
    props: PqrReceivedThroughParamsDataProps
) => {
    const { formik } = usePqrReceivedThroughData(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    required
                    errors={formik.errors.name}
                    value={formik.values.name}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Tipo PQR"
                    name="parent"
                    size="small"
                    required
                    errors={formik.values.parent}
                    value={formik.values.parent}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Plantilla Email - estado de seguimiento"
                    name="alertFollowUp"
                    size="small"
                    required
                    errors={formik.errors.alertFollowUp}
                    value={formik.values.alertFollowUp}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Plantilla Email - estado tramitado"
                    name="alertProcessed"
                    size="small"
                    required
                    errors={formik.errors.alertProcessed}
                    value={formik.values.alertProcessed}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Descripción"
                    name="extra2"
                    size="small"
                    rows={3}
                    errors={formik.values.extra2}
                    value={formik.values.extra2}
                />
            </Grid>
        </Grid>
    );
};
